import { validator } from "@/utils/validator";

export const loginSchema = validator.object().shape({
  companyCode: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("企業ID").required(),
  email: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("メールアドレス").required(),
  password: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("パスワード").required(),
});
